import {
  AnswerType,
  Demander,
  MultiplyingFactor,
} from "../../assets/data/Constants";
import { labelids } from "../../assets/data/TkExplanationProperty";
import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import { TkGetCodeList } from "../../utils/TkGetCode";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";

const tableListContractor: ITkFakeTableLineProps[] = [
  {
    keyword: "lineTitle",
    type: "lineTitle",
    lineTitle: labelids.labelid.LBLC060134_01,
  },
  {
    title: "請求者選択",
    keyword: "decisionDemanderKbn",
    type: "selectForm",
    selectPropsList: TkGetCodeList(Demander),
    disabled: true,
  },
  {
    keyword: "brank",
    type: "lineTitle",
  },
  {
    title: "共済契約者番号",
    keyword: "contractorNo",
    inputProps: { maxLength: 6 },
    disabled: true,
  },
  {
    title: "共済契約者名",
    keyword: "contractorName",
    inputProps: { maxLength: 85 },
    type: "label",
    disabled: true,
    requiredIcon: true,
  },
  {
    title: "代表者",
    keyword: "directorName",
    type: "name",
    disabled: true,
  },
  {
    title: "職員氏名",
    keyword: "staffName",
    type: "name",
    disabled: true,
    requiredIcon: true,
  },
  {
    title: "職員番号",
    keyword: "staffNo",
    inputProps: { maxLength: 5 },
    disabled: true,
    requiredIcon: true,
  },
  {
    title: "退職（予定）年月日①",
    keyword: "retirePlanDay1",
    type: "date",
    minDate: new Date("1900/01/01"),
    maxDate: new Date("2099/12/31"),
    disabled: true,
    requiredIcon: true,
  },
  {
    title: "退職月の直前４月から退職月までの期間のならない月①",
    keyword: "unaccountedMonthsTotal1",
    type: "amount",
    innerText: "月",
    inputProps: { maxLength: 2 },
    disabled: true,
    requiredIcon: true,
  },
  {
    title: "退職月の直近６ヶ月の平均俸給①",
    keyword: "sixMonthSalaryAverage1Contractor",
    type: "amount",
    inputProps: { maxLength: 9 },
    disabled: true,
    requiredIcon: true,
  },
  {
    title: "退職（予定）年月日②",
    keyword: "retirePlanDay2",
    type: "date",
    minDate: new Date("1900/01/01"),
    maxDate: new Date("2099/12/31"),
    disabled: true,
  },
  {
    title: "退職月の直前４月から退職月までの期間のならない月②",
    keyword: "unaccountedMonthsTotal2",
    type: "amount",
    innerText: "月",
    inputProps: { maxLength: 2 },
    disabled: true,
  },
  {
    title: "退職月の直近６ヶ月の平均俸給②",
    keyword: "sixMonthSalaryAverage2",
    type: "amount",
    inputProps: { maxLength: 9 },
    disabled: true,
  },
  {
    title: "依頼理由",
    keyword: "requestReason",
    inputProps: { maxLength: 85 },
    disabled: true,
    requiredIcon: true,
  },
  {
    title: "担当者氏名",
    keyword: "demanderName",
    type: "name",
    disabled: true,
  },
  {
    title: "担当者電話番号",
    keyword: "contractorTel",
    type: "phoneNum",
    disabled: true,
  },
  {
    title: "仮退職年月日以前６ヶ月の給与台帳（写）",
    keyword: "payroll",
    type: "fileUpload",
    downloadBase64: true,
    disabled: true,
    requiredIcon: true,
  },
];

const tableListStaff: ITkFakeTableLineProps[] = [
  {
    keyword: "lineTitle",
    type: "lineTitle",
    lineTitle: labelids.labelid.LBLC060134_01,
  },
  {
    title: "請求者選択",
    keyword: "decisionDemanderKbn",
    type: "selectForm",
    selectPropsList: TkGetCodeList(Demander),
    disabled: true,
  },
  {
    keyword: "brank",
    type: "lineTitle",
  },
  {
    title: "共済契約者名",
    keyword: "contractorName",
    inputProps: { maxLength: 85 },
    type: "label",
    disabled: true,
    requiredIcon: true,
  },
  {
    title: "施設名",
    keyword: "facilityName",
    inputProps: { maxLength: 20 },
    disabled: true,
  },
  {
    title: "職員氏名",
    keyword: "staffName",
    type: "name",
    disabled: true,
    requiredIcon: true,
  },
  {
    title: "職員生年月日",
    keyword: "staffBirthday",
    type: "date",
    minDate: new Date("1900/01/01"),
    maxDate: new Date(),
    disabled: true,
  },
  {
    title: "職員住所郵便番号",
    keyword: "zipcode",
    type: "addressSearch",
    disabled: true,
  },
  {
    title: "職員住所",
    keyword: "staffAddress",
    type: "locationGroup",
    disabled: true,
  },
  {
    title: "退職（予定）年月日①",
    keyword: "retirePlanDay1",
    type: "date",
    minDate: new Date("1900/01/01"),
    maxDate: new Date("2099/12/31"),
    disabled: true,
    requiredIcon: true,
  },
  {
    title: "退職月の直近６ヶ月の平均俸給①",
    keyword: "sixMonthSalaryAverage1Staff",
    type: "amount",
    inputProps: { maxLength: 9 },
    disabled: true,
    requiredIcon: true,
  },
  {
    title: "退職（予定）年月日②",
    keyword: "retirePlanDay2",
    type: "date",
    minDate: new Date("1900/01/01"),
    maxDate: new Date("2099/12/31"),
    disabled: true,
  },
  {
    title: "退職月の直近６ヶ月の平均俸給②",
    keyword: "sixMonthSalaryAverage2",
    type: "amount",
    inputProps: { maxLength: 9 },
    disabled: true,
  },
  {
    title: "依頼理由",
    keyword: "requestReason",
    inputProps: { maxLength: 85 },
    disabled: true,
    requiredIcon: true,
  },
  {
    title: "仮退職年月日以前６ヶ月の給与台帳（写）",
    keyword: "payroll",
    type: "fileUpload",
    downloadBase64: true,
    id: "1",
    disabled: true,
    requiredIcon: true,
  },
  {
    title: "身分証明書（写）",
    keyword: "identification",
    type: "fileUpload",
    downloadBase64: true,
    id: "2",
    disabled: true,
    requiredIcon: true,
  },
];

const tableListLawyer: ITkFakeTableLineProps[] = [
  {
    keyword: "lineTitle",
    type: "lineTitle",
    lineTitle: labelids.labelid.LBLC060134_01,
  },
  {
    title: "請求者選択",
    keyword: "decisionDemanderKbn",
    type: "selectForm",
    selectPropsList: TkGetCodeList(Demander),
    disabled: true,
  },
  {
    keyword: "brank",
    type: "lineTitle",
  },
  {
    title: "共済契約者名",
    keyword: "contractorName",
    inputProps: { maxLength: 85 },
    type: "label",
    disabled: true,
    requiredIcon: true,
  },
  {
    title: "施設名",
    keyword: "facilityName",
    inputProps: { maxLength: 20 },
    disabled: true,
  },
  {
    title: "所属弁護士会名",
    keyword: "lawyerName",
    inputProps: { maxLength: 85 },
  },
  {
    title: "所属弁護士会　登録番号",
    keyword: "lawyerNo",
    inputProps: { maxLength: 60 },
    disabled: true,
  },
  {
    title: "送付先電話番号",
    keyword: "deliveryTel",
    type: "phoneNum",
    disabled: true,
  },
  {
    title: "送付先郵便番号",
    keyword: "deliveryZipcode",
    type: "addressSearch",
    disabled: true,
  },
  {
    title: "送付先住所",
    keyword: "deliveryAddress",
    type: "locationGroup",
    disabled: true,
  },
  {
    title: "職員氏名",
    keyword: "staffName",
    type: "name",
    disabled: true,
    requiredIcon: true,
  },
  {
    title: "職員生年月日",
    keyword: "staffBirthday",
    type: "date",
    minDate: new Date("1900/01/01"),
    maxDate: new Date(),
    disabled: true,
  },
  {
    title: "職員郵便番号",
    keyword: "zipcode",
    type: "addressSearch",
    disabled: true,
  },
  {
    title: "職員住所",
    keyword: "staffAddress",
    type: "locationGroup",
    disabled: true,
  },
  {
    title: "退職（予定）年月日①",
    keyword: "retirePlanDay1",
    type: "date",
    minDate: new Date("1900/01/01"),
    maxDate: new Date("2099/12/31"),
    disabled: true,
    requiredIcon: true,
  },
  {
    title: "退職月の直近６ヶ月の平均俸給①",
    keyword: "sixMonthSalaryAverage1Lawyer",
    type: "amount",
    inputProps: { maxLength: 9 },
    disabled: true,
    requiredIcon: true,
  },
  {
    title: "退職（予定）年月日②",
    keyword: "retirePlanDay2",
    type: "date",
    minDate: new Date("1900/01/01"),
    maxDate: new Date("2099/12/31"),
    disabled: true,
  },
  {
    title: "退職月の直近６ヶ月の平均俸給②",
    keyword: "sixMonthSalaryAverage2",
    type: "amount",
    inputProps: { maxLength: 9 },
    disabled: true,
  },
  {
    title: "依頼理由",
    keyword: "requestReason",
    inputProps: { maxLength: 85 },
    disabled: true,
    requiredIcon: true,
  },
  {
    title: "仮退職年月日以前６ヶ月の給与台帳（写）",
    keyword: "payroll",
    type: "fileUpload",
    downloadBase64: true,
    id: "1",
    disabled: true,
    requiredIcon: true,
  },
  {
    title: "委任状",
    keyword: "commission",
    type: "fileUpload",
    downloadBase64: true,
    id: "2",
    disabled: true,
    requiredIcon: true,
  },
];

const tableListAnswer: ITkFakeTableLineProps[] = [
  {
    keyword: "brank",
    type: "lineTitle",
  },
  {
    title: "回答種類",
    keyword: "answerPossibilityFlg",
    type: "radio",
    radioPropsList: TkGetCodeList(AnswerType),
    showLine: false,
  },
  {
    title: "被共済職員氏名",
    keyword: "answerStaffName",
    type: "name",
    showLine: false,
  },
  {
    title: "生年月日",
    keyword: "answerBirthday",
    type: "date",
    minDate: new Date("1900/01/01"),
    maxDate: new Date("2099/12/31"),
    showLine: false,
  },
  {
    title: "勤務先",
    keyword: "workPlace",
    inputProps: { maxLength: 85 },
    showLine: false,
  },
  {
    title: "退職手当金見込額①",
    keyword: "retirementAllowanceExpectAmt1",
    type: "amount",
    inputProps: { maxLength: 9 },
    showLine: false,
  },
  {
    title: "制度改正加入年月日①",
    keyword: "firstJoinDate1",
    type: "date",
    minDate: new Date("1900/01/01"),
    maxDate: new Date("2099/12/31"),
    showLine: false,
  },
  {
    title: "仮退職年月日①",
    keyword: "tentativeRetireDate1",
    type: "date",
    minDate: new Date("1900/01/01"),
    maxDate: new Date("2099/12/31"),
    showLine: false,
  },
  {
    title: "被共済職員期間①",
    keyword: "maePeriod1",
    type: "nodeInLine",
    showLine: false,
  },
  {
    title: "支給乗率①",
    keyword: "paymentMultiplierKbn1",
    type: "selectForm",
    selectPropsList: TkGetCodeList(MultiplyingFactor),
    showLine: false,
  },
  {
    title: "退職手当金見込額②",
    keyword: "retirementAllowanceExpectAmt2",
    type: "amount",
    inputProps: { maxLength: 9 },
    showLine: false,
  },
  {
    title: "制度改正加入年月日②",
    keyword: "firstJoinDate2",
    type: "date",
    minDate: new Date("1900/01/01"),
    maxDate: new Date("2099/12/31"),
    showLine: false,
  },
  {
    title: "仮退職年月日②",
    keyword: "tentativeRetireDate2",
    type: "date",
    minDate: new Date("1900/01/01"),
    maxDate: new Date("2099/12/31"),
    showLine: false,
  },
  {
    title: "被共済職員期間②",
    keyword: "maePeriod2",
    type: "nodeInLine",
    showLine: false,
  },
  {
    title: "支給乗率②",
    keyword: "paymentMultiplierKbn2",
    type: "selectForm",
    selectPropsList: TkGetCodeList(MultiplyingFactor),
    showLine: false,
  },
  {
    title: "回答不可理由",
    keyword: "noAnswerReason",
    inputProps: { maxLength: 85 },
    showLine: false,
  },
];

const tableListAnswerFor00: ITkFakeTableLineProps[] = [
  {
    keyword: "brank",
    type: "lineTitle",
  },
  {
    title: "回答種類",
    keyword: "answerPossibilityFlg",
    type: "radio",
    radioPropsList: TkGetCodeList(AnswerType),
    showLine: false,
  },
  {
    title: "被共済職員氏名",
    keyword: "answerStaffName",
    type: "name",
    showLine: false,
  },
  {
    title: "生年月日",
    keyword: "answerBirthday",
    type: "date",
    minDate: new Date("1900/01/01"),
    maxDate: new Date("2099/12/31"),
    showLine: false,
  },
  {
    title: "勤務先",
    keyword: "workPlace",
    inputProps: { maxLength: 85 },
    showLine: false,
  },
  {
    title: "回答不可理由",
    keyword: "noAnswerReason",
    inputProps: { maxLength: 85 },
    showLine: false,
  },
];

const addressValidation = {
  validate: (data: any) => {
    let error = {
      prefectures: "",
      city: "",
      address: "",
    };

    error = {
      prefectures: "",
      city:
        data?.city.length > 20
          ? TkPropertyMessageGet("TKMSG_SCR0046E", "20")
          : !data?.city.match(/^[^ -~｡-ﾟ]*$/)
          ? TkPropertyMessageGet("TKMSG_SCR0061E")
          : "",
      address:
        data?.address.length > 85
          ? TkPropertyMessageGet("TKMSG_SCR0046E", "85")
          : !data?.address.match(/^[^ -~｡-ﾟ]*$/)
          ? TkPropertyMessageGet("TKMSG_SCR0061E")
          : "",
    };

    if (error.prefectures !== "" || error.city !== "" || error.address !== "") {
      return JSON.stringify(error);
    }
  },
};

const schema = {
  contractorNo: {
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 6,
      message: TkPropertyMessageGet("TKMSG_SCR0077E", "6"),
    },
    minLength: {
      value: 6,
      message: TkPropertyMessageGet("TKMSG_SCR0077E", "6"),
    },
  },
  contractorName: {
    required: {
      value: true,
      message: TkPropertyMessageGet("TKMSG_SCR0043E"),
    },
    pattern: {
      value: /^[^ -~｡-ﾟ]+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0061E"),
    },
    maxLength: {
      value: 85,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "85"),
    },
  },
  directorName: {
    pattern: {
      value: /^[^ -~｡-ﾟａ-ｚＡ-Ｚ]+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0073E"),
    },
    maxLength: {
      value: 48,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "47"),
    },
  },
  staffName: {
    required: {
      value: true,
      message: TkPropertyMessageGet("TKMSG_SCR0043E"),
    },
    pattern: {
      value: /^[^ -~｡-ﾟａ-ｚＡ-Ｚ]+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0073E"),
    },
    maxLength: {
      value: 48,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "47"),
    },
  },
  staffNo: {
    required: {
      value: true,
      message: TkPropertyMessageGet("TKMSG_SCR0043E"),
    },
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 5,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "5"),
    },
  },
  retirePlanDay1: {
    required: {
      value: true,
      message: TkPropertyMessageGet("TKMSG_SCR0043E"),
    },
  },
  requestReason: {
    required: {
      value: true,
      message: TkPropertyMessageGet("TKMSG_SCR0043E"),
    },
    pattern: {
      value: /^[^ -~｡-ﾟ]+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0061E"),
    },
    maxLength: {
      value: 85,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "85"),
    },
  },
  demanderName: {
    pattern: {
      value: /^[^ -~｡-ﾟａ-ｚＡ-Ｚ]+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0073E"),
    },
    maxLength: {
      value: 48,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "47"),
    },
  },
  contractorTel: {
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 19,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "19"),
    },
  },
  zipcode: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 7,
      message: TkPropertyMessageGet("TKMSG_SCR0077E", "7"),
    },
    minLength: {
      value: 7,
      message: TkPropertyMessageGet("TKMSG_SCR0077E", "7"),
    },
  },
  staffAddress: addressValidation,
  facilityName: {
    pattern: {
      value: /^[^ -~｡-ﾟ]+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0061E"),
    },
    maxLength: {
      value: 20,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "20"),
    },
  },
  lawyerName: {
    pattern: {
      value: /^[^ -~｡-ﾟ]+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0061E"),
    },
    maxLength: {
      value: 85,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "85"),
    },
  },
  lawyerNo: {
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 60,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "60"),
    },
  },
  deliveryTel: {
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 19,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "19"),
    },
  },
  deliveryZipcode: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 7,
      message: TkPropertyMessageGet("TKMSG_SCR0077E", "7"),
    },
    minLength: {
      value: 7,
      message: TkPropertyMessageGet("TKMSG_SCR0077E", "7"),
    },
  },
  deliveryAddress: addressValidation,
  workPlace: {
    pattern: {
      value: /^[^ -~｡-ﾟ]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0061E"),
    },
    maxLength: {
      value: 85,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "85"),
    },
  },
  noAnswerReason: {
    pattern: {
      value: /^[^ -~｡-ﾟ]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0061E"),
    },
    maxLength: {
      value: 85,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "85"),
    },
  },
  unaccountedMonthsTotal1: {
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    max: {
      value: 12,
      message: TkPropertyMessageGet("TKMSG_SCR0048E", "12"),
    },
  },
  unaccountedMonthsTotal2: {
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    max: {
      value: 12,
      message: TkPropertyMessageGet("TKMSG_SCR0048E", "12"),
    },
  },
  sixMonthSalaryAverage2: {
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 9,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "9"),
    },
  },
  maePeriod1: {
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
  },
  maePeriod2: {
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
  },
  payroll: {
    required: {
      value: true,
      message: TkPropertyMessageGet("TKMSG_SCR0043E"),
    },
  },
};

const contractorSchema = {
  unaccountedMonthsTotal1: {
    required: {
      value: true,
      message: TkPropertyMessageGet("TKMSG_SCR0043E"),
    },
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    max: {
      value: 12,
      message: TkPropertyMessageGet("TKMSG_SCR0048E", "12"),
    },
  },
  sixMonthSalaryAverage1Contractor: {
    required: {
      value: true,
      message: TkPropertyMessageGet("TKMSG_SCR0043E"),
    },
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 9,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "9"),
    },
  },
};

const staffSchema = {
  identification: {
    required: {
      value: true,
      message: TkPropertyMessageGet("TKMSG_SCR0043E"),
    },
  },
  sixMonthSalaryAverage1Staff: {
    required: {
      value: true,
      message: TkPropertyMessageGet("TKMSG_SCR0043E"),
    },
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 9,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "9"),
    },
  },
};

const lawyerSchema = {
  commission: {
    required: {
      value: true,
      message: TkPropertyMessageGet("TKMSG_SCR0043E"),
    },
  },
  sixMonthSalaryAverage1Lawyer: {
    required: {
      value: true,
      message: TkPropertyMessageGet("TKMSG_SCR0043E"),
    },
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 9,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "9"),
    },
  },
};

const memoHeadList = [
  {
    headTitle: "担当者",
  },
  {
    headTitle: "処理",
  },
  {
    headTitle: "実施日",
  },
  {
    headTitle: "コメント",
  },
];

export {
  tableListContractor,
  tableListStaff,
  tableListLawyer,
  tableListAnswer,
  tableListAnswerFor00,
  schema,
  contractorSchema,
  staffSchema,
  lawyerSchema,
  memoHeadList,
};
